
'use strict';

(function () {
  if (!customElements.get('featured-blog')) {
    class FeaturedBlog extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.slider = this.querySelector('.swiper');
      }

      connectedCallback() {
        if (typeof Swiper !== 'undefined') {
          this.initSwiper();
        } else {
          window.addEventListener('load', () => this.initSwiper());
        }
      }

      disconnectedCallback() {
        this.destroySwiper();
      }

      initSwiper() {
        if (!this.slider || this.swiper) return;
        if (typeof Swiper === 'undefined') return;

        let {
          slidesLength,
          spaceBetween = 16,
          spaceBetweenMd = 16,
          slidesPerViewLg,
          autoplay: autoplayEnabled,
          autoplaySpeed = 5000,
        } = this.dataset;

        slidesLength = +slidesLength;
        slidesPerViewLg = +slidesPerViewLg;
        autoplaySpeed = +autoplaySpeed;

        var slidesPerView = 2.15;
        var slidesPerViewMd = Math.min(slidesLength, Math.ceil((slidesPerView + slidesPerViewLg) / 2));

        var swiperParams = {
          speed: 400,
          slidesPerView: slidesPerView,
          spaceBetween: +spaceBetween,
          loop: slidesLength > slidesPerViewLg,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          scrollbar: {
            el: this.querySelector('.swiper-scrollbar'),
            draggable: true,
          },
          breakpoints: {
            750: {
              slidesPerView: slidesPerViewMd,
              spaceBetween: +spaceBetweenMd,
            },
            990: {
              slidesPerView: slidesPerViewLg,
              spaceBetween: 20,
            },
          },
        };

        if (autoplayEnabled === 'true') {
          swiperParams.autoplay = {
            delay: autoplaySpeed,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          };
        }

        this.swiper = new Swiper(this.slider, swiperParams);
      }

      destroySwiper() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }
    }

    customElements.define('featured-blog', FeaturedBlog);
  }
})();
